package com.tovtalk.data.local

import com.tovtalk.domain.entity.Post
import kotlin.concurrent.Volatile

/**
 * In-memory cache for passing a [Post] to [PostDetailScreen] when navigating from feed/profile/notifications.
 * Avoids redundant getReelById API call when we already have the post.
 * The single slot is @Volatile so a write on one thread is visible to a reader on another;
 * [getAndRemove] takes-and-clears in one step to avoid two consumers getting the same post.
 */
object PostDetailCache {
    @Volatile
    private var cached: Post? = null

    fun set(post: Post) {
        cached = post
    }

    /**
     * Returns and removes the cached post if it matches [postRef]. Clears the slot first so a
     * concurrent caller can't read the same entry, then matches on the snapshot.
     */
    fun getAndRemove(postRef: String): Post? {
        val p = cached
        cached = null
        return if (p != null && p.ref == postRef) p else null
    }
}
